import { type TFunction } from 'i18next';

import { today } from 'app/main/components/Utils';

export default function getDefaultModifiedModelAdd({
	settings,
	sysSettings,
	userData,
	t
}: {
	settings: any;
	sysSettings: any;
	userData: any;
	t: TFunction;
}) {
	const baseAddModel = {
		[`${settings.modu_short}_d_from`]: today().toISOString()
	};

	if (settings.modu_title === 'users') {
		baseAddModel.user_end_time = sysSettings.workday_t_end;
		baseAddModel.user_start_time = sysSettings.workday_t_start;
		baseAddModel.user_lunch_end_time = sysSettings.lunch_t_end;
		baseAddModel.user_lunch_start_time = sysSettings.lunch_t_start;
	}

	if (settings.modu_title !== 'skills_evaluations') {
		baseAddModel[`${settings.modu_short}_user_assigned_uid`] = userData.user_uid;
	}

	return baseAddModel;
}
